import React from 'react';
import { Icon } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ShouldComponentRender from './ShouldComponentRender';
import { ENTITY_ACCESS_TYPE, RESOURCE_TYPE, RESOURCES } from '../../HelperMethods/role-resource-constants';
// eslint-disable-next-line import/no-cycle
import AssigneeThreeDotMenu from './AssigneeThreeDotMenu';
import styles from './taskBox/TaskBox.module.css';
import { CONTAINERS, pushView } from './cardNavigationComponent/cardNavigationRedux';
// eslint-disable-next-line import/no-cycle
import TaskAssigneeCard from './taskAssigneeCard/TaskAssigneeCard';
import { getAssigneeNamesAndCount } from '../map/helper';
import { parseJSONStringToObject } from '../../HelperMethods/UtilityFunctions';
// eslint-disable-next-line import/no-cycle
import AssigneeCard from './assigneeCard/AssigneeCard';
import { shouldShowForLoggedInVendor } from '../../HelperMethods/TaskUtilities';

function TaskAssignee({ task, container }) {
  const user = useSelector((state) => state.appReducer.loggedInUser);
  const assigneeIds = task.assigneeIds && task.assigneeIds.filter((a) => !a.isDeleted).map((a) => a.assigneeId);
  const assigneeObject = parseJSONStringToObject(task.assignee);
  const { assignees, remainingCount } = getAssigneeNamesAndCount(assigneeIds, assigneeObject);
  const dispatch = useDispatch();
  return (
    <>
      <Icon disabled name="user circle outline" />
      &nbsp;
      {assignees.length > 0 ? (
        <span>
          {assignees.map((a) => (
            <AssigneeName assignee={a} key={a.id} container={container} user={user} />
          ))}{' '}
          {remainingCount ? `+ ${remainingCount}` : ''}
          <ShouldComponentRender
            resource={RESOURCES.ENTITY.TASK}
            resourceType={RESOURCE_TYPE.ENTITY}
            entity={task}
            entityAccessType={ENTITY_ACCESS_TYPE.UPDATE}
          >
            {!task.isTaskLocked && shouldShowForLoggedInVendor(assignees, user) ? (
              <AssigneeThreeDotMenu container={container} task={task} />
            ) : null}
          </ShouldComponentRender>
        </span>
      ) : (
        <span style={{ fontFamily: 'JoynFontLight' }}>
          Unassigned
          <ShouldComponentRender
            resource={RESOURCES.ENTITY.TASK}
            resourceType={RESOURCE_TYPE.ENTITY}
            entity={task}
            entityAccessType={ENTITY_ACCESS_TYPE.UPDATE}
          >
            <div
              className={styles.plusIcon}
              onClick={() => {
                dispatch(pushView(container, { component: TaskAssigneeCard, props: { taskId: task.id } }));
              }}
            >
              +
            </div>
          </ShouldComponentRender>
        </span>
      )}
    </>
  );
}

const AssigneeName = ({ assignee, container, user }) => {
  const dispatch = useDispatch();
  const showAssigneeDetails = () => {
    if (assignee.vendorId === user.vendorId) {
      dispatch(pushView(container, { component: AssigneeCard, props: { assigneeId: assignee.id } }));
    }
  };
  return (
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    <span
      role="button"
      onClick={() => {
        showAssigneeDetails();
      }}
      className={styles.singleAssigneeName}
    >
      {`${assignee.firstName} ${assignee.lastName}`}
    </span>
  );
};

AssigneeName.propTypes = {
  assignee: PropTypes.shape({
    id: PropTypes.string.isRequired,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    vendorId: PropTypes.string,
  }).isRequired,
  container: PropTypes.oneOf(Object.values(CONTAINERS)).isRequired,
  user: PropTypes.shape({
    vendorId: PropTypes.string,
  }).isRequired,
};

TaskAssignee.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.string.isRequired,
    assigneeIds: PropTypes.array.isRequired,
    priority: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    startTime: PropTypes.string.isRequired,
    endTime: PropTypes.string.isRequired,
    assignee: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isTaskLocked: PropTypes.bool,
  }).isRequired,
  container: PropTypes.oneOf(Object.values(CONTAINERS)).isRequired,
};

export default TaskAssignee;
